import { ReactNode } from 'react';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';
import circleCheck from 'icons/circle-check.svg';

export const GiftCardHeroWrapper = styled.div`
	background: linear-gradient(-180deg, rgb(252, 252, 252) 0%, rgb(247, 247, 247) 100%);
	color: ${palette('white')};
	position: relative;
	z-index: 0;
`;

export const Grid = styled(GridWrapper)`
	margin: 0;

	${minWidth('tablet')} {
		grid-template-columns: 1fr;
	}

	${minWidth('desktop')} {
		grid-template-columns: 50% 50%;
	}
`;

export const SignupContainer = styled.div`
	${minWidth('desktop')} {
		width: 50%;
	}
	margin: 0 auto;
`;

export const GiftCardHeroContent = styled.div`
	margin: 0 auto;
	text-align: left;

	${minWidth('tablet')} {
		width: 50%;
	}

	${minWidth('desktop')} {
		margin: 0 auto 0 0;
		width: calc(100% - 4rem);
	}
`;

export const GiftCardHeroHeading = styled.h2`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 24px;

	${minWidth('desktop')} {
		margin-bottom: 32px;
	}
`;

export const GiftCardHeroSubheading = styled.h5`
	align-items: center;
	display: flex;
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 18px;
`;

export const Check = styled(circleCheck)`
	flex: 0 0 20px;
	height: 20px;
	margin-right: 10px;
	width: 20px;

	& path {
		fill: ${palette('white')};
	}
`;

const HolidayUpsellWrapper = styled.div`
	color: #fff;
	display: flex;
	justify-content: flex-end;
	text-align: left;
	width: 100%;
	position: relative;
`;

const HolidayUpsellContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 40px;
	padding: 120px 16px 32px;
	width: 100%;

	${minWidth('desktop')} {
		padding: 20vh 0 1.11rem;
	}
`;

export const HolidayUpsell = ({ children }: { children?: ReactNode }) => {
	return (
		<HolidayUpsellWrapper>
			<HolidayUpsellContainer>{children}</HolidayUpsellContainer>
		</HolidayUpsellWrapper>
	);
};

const HolidayFormWrapper = styled.div`
	color: #000;

	${minWidth('desktop')} {
		min-height: 100vh;
	}
`;

const HolidayFormInnerContainer = styled.div`
	display: flex;
	justify-content: center;
	padding: 1.33rem 0.77rem;
	width: 100%;

	${minWidth('desktop')} {
		padding: 20vh 0 0.77rem;
	}
`;

export const HolidayFormContainer = ({ children, id }: { children?: ReactNode; id?: string }) => {
	return (
		<HolidayFormWrapper id={id}>
			<HolidayFormInnerContainer>{children}</HolidayFormInnerContainer>
		</HolidayFormWrapper>
	);
};

export const CardSection = styled.div`
	position: relative;
	width: 100%;
	height: 237px;

	${minWidth('mobileLarge')} {
		height: 600px;
	}
`;

export const IconWrapper = styled.div`
	margin: 0 auto 0.77rem;
	text-align: center;
`;

export const FullscreenBackgroundDesktop = styled(FullscreenBackground)`
	display: none;

	${minWidth('desktop')} {
		display: block;
		width: 50%;
		z-index: 0;
	}
`;

export const FullscreenBackgroundMobile = styled(FullscreenBackground)`
	${minWidth('desktop')} {
		display: none;
	}
`;

export const AccountWrapper = styled.div`
	margin-top: 28px;
	text-align: center;

	${minWidth('tablet')} {
		margin-top: 0;
	}
`;
